import "./AccountStatementTable.scss";
import React, {useEffect, useState} from "react";
import {timeToDate, tsToDate} from "../../helpers/date.helper";
import { connectAccountStatementTable } from "./connectAccountStatementTable";
import { getCurrencyFormatWithZeroAfterDot } from "../../helpers/getCurrencyFormat.helper";

const AccountStatementTable = ({accountStatement, timeSettings, setSelectPNLItem}) => {
    const [accountStatementMap, setAccountStatementMap] = useState(new Map());

    const buildAccountStatementMap = () => {
        if (!accountStatement)
            {return;}

        accountStatementMap.clear();
        accountStatement.data.forEach(d => {
            const ketMap = timeToDate(d.date);
            const mapValue = accountStatementMap.get(ketMap.time);

            if (mapValue) {
                mapValue.data.push(d);
            } else {
                accountStatementMap.set(ketMap.time, {
                    dateString: ketMap.dateString,
                    data: [d],
                });
            }
        },
    );
        setAccountStatementMap(new Map([...accountStatementMap].sort((a, b) => b[0] - a[0])));
    };

    useEffect(() => {
        if (accountStatement && accountStatement.data) {
            buildAccountStatementMap(accountStatement);
        } else {
          setAccountStatementMap(new Map());
        }

    }, [accountStatement]);

    const handleClickName = (item) => {
        setSelectPNLItem(item);
    };

    return (
    <section className="AccountStatementTable">
      <div className="AccountStatementTable__table">
        <h6 className="AccountStatementTable__table-title">Total P&L:&nbsp;
          <span
            className={accountStatement?.totalPnl >= 0 ? "green" : "red"}>{getCurrencyFormatWithZeroAfterDot(accountStatement?.totalPnl)}</span>
        </h6>
        <ul className="AccountStatementTable__table-header">
          <li><span>Date</span></li>
          <li>Description</li>
          <li className="info-right">P&L</li>
          <li className="info-right">Credit <br /> Limit</li>
          <li className="info-right">Balance</li>
        </ul>
        <div className="AccountStatementTable__table-body">
          { accountStatementMap && accountStatementMap?.size ?
            [...accountStatementMap].map((itemWithDate) =>
            <div key={itemWithDate}>
              <div className="AccountStatementTable__table-body-time">
                <span>{tsToDate(itemWithDate[0], timeSettings?.timeZoneName)
                  .split(" ")[0]
                  .split("/")
                  .map((dateItem) => dateItem.length === 1 ? "0" + dateItem : dateItem)
                  .join("/")}
                </span>
              </div>
              {itemWithDate[1]?.data.map((item, index) => (
                  <ul className="AccountStatementTable__table-body-row" key={item?.date + index}>
                    <li className="info-right">
                      <span className="text-color">{tsToDate(item?.date, timeSettings?.timeZoneName).split(" ")[1]}</span>
                    </li>
                    <li className="AccountStatementTable__table-body-row-description">
                      <div className="AccountStatementTable__table-body-row-description-action-name">
                        <span>{item?.actionDisplayName}</span></div>
                      {item?.description?.eventName && item?.description?.marketName &&
                        <div onClick={() => handleClickName(item)} className="AccountStatementTable__table-body-row-description-name">
                          <span>{item?.description?.eventName} - {item?.description?.marketName}</span>
                        </div>
                      }
                    </li>
                    <li className={`info-right ${item?.pnl >= 0 ? "green" : "red"}`}>{getCurrencyFormatWithZeroAfterDot(item?.pnl)}</li>
                    <li className="info-right">{(getCurrencyFormatWithZeroAfterDot(item?.creditLimit) === '0.00' ? '-' : getCurrencyFormatWithZeroAfterDot(item?.creditLimit)) || "-"}</li>
                    <li className={`info-right ${item?.balance >= 0 ? "green" : "red"}`}>{getCurrencyFormatWithZeroAfterDot(item.balance)}</li>
                  </ul>
                ),
              )}
            </div>,
          )
            :
            <div className="AccountStatementTable__table-body">
              <div className="AccountStatementTable__table-body-empty"> No data to display. Try changing filters and search again</div>
            </div>
          }
        </div>
      </div>
    </section>
    );
};

export default connectAccountStatementTable()(AccountStatementTable);
